import React from 'react';
import { Page } from 'components/core/Page';
import { Spinner } from 'components/core/Spinner';

import './StatePageSkeleton.scss';

/**
 * StatePageSkeleton - Loading skeleton for state landing pages
 *
 * Maintains the same layout structure as StatePage to prevent CLS
 * (Cumulative Layout Shift) during route transitions.
 *
 * Key dimensions:
 * - Hero area: 420px (matches StateHero min-height)
 * - Content area: Grid layout matching CityCardList
 *   - Mobile: 1 column, 24px padding
 *   - Medium: 2 columns, 36px padding
 *   - XXLarge: 3 columns, responsive padding
 *
 * This prevents the footer from jumping to the top during navigation
 * between state pages.
 */
export default function StatePageSkeleton() {
	return (
		<Page className="state-landing-page state-landing-page--loading">
			{/* Hero skeleton - reserves same space as StateHero */}
			<div className="state-hero-skeleton">
				<div className="state-hero-skeleton__overlay">
					<Spinner />
				</div>
			</div>

			{/* Content skeleton - matches CityCardList grid layout */}
			<div className="state-content-skeleton">
				{[...Array(6)].map((_, index) => (
					<div
						key={index}
						className="state-content-skeleton__block"
					>
						{/* Header skeleton with title */}
						<div className="skeleton-header">
							<div className="skeleton-title" />
						</div>
						{/* Accordion items skeleton */}
						<div className="skeleton-content">
							{[...Array(3)].map((_, accordionIndex) => (
								<div
									key={accordionIndex}
									className="skeleton-accordion-item"
								/>
							))}
						</div>
						{/* Button skeleton */}
						<div className="skeleton-button" />
					</div>
				))}
			</div>
		</Page>
	);
}
